<template>
    <div>
        <rednax-datatable :url="'/vue/sales/crm/company'" :columns="company_columns" :filter="company_filter" @updateFilter="company_filter=$event" :per-page="300" @rowclick="rowClick" history>
            <div class="row">
                <div class="col-lg-3">
                    <input type="text" v-model="company_filter.search" class="form-control">
                </div>
                <div class="col-lg-3">
                    <vue-select
                        v-model="company_filter.is_customer"
                        :options="customer_status_options"
                        placeholder="-- Kunder --"
                        :reduce="(opt) => opt.id"
                    ></vue-select>
                </div>
                <div class="col-lg-3">
                    <sales-crm-users-filter
                        v-model="company_filter.user_id"
                        placeholder="-- Alla säljare --"
                        :reduce="opt => opt.id"
                    ></sales-crm-users-filter>
                </div>
            </div>

            <template #cell_name="{row}">
                <nobr>{{ row.name }}</nobr>
            </template>
            <template #cell_org_no="{row}">
                <nobr>{{ row.org_no }}</nobr>
            </template>
            <template #cell_suffix="{row}">
                <nobr>{{ row.suffix }}</nobr>
            </template>
            <template #cell_customer_ids="{row}">
                <i v-if="row.customer_ids && row.customer_ids.length > 0" class="icon-checkmark"></i>
            </template>
            <template #cell_tags="{row}">
                <div v-if="row.tags" style="margin-bottom: -0.3125rem !important;">
                    <span
                        v-for="tag in row.tags.split(',')" :key="'c-' + row.id + '-t-' + tag"
                        class="badge badge-secondary mr-1 mb-1"
                    >{{ tag }}</span>
                </div>
            </template>
        </rednax-datatable>
    </div>
</template>

<script>
import RednaxDatatable from '@components/Datatable/RednaxDatatableComponent';
import VueSelect from '@components/Wrappers/VueSelect.vue';
import SalesCrmUsersFilter from '@components/Filters/SalesCrmUsersFilter.vue';
import { mapState } from 'pinia';
import { useAuthStore } from '@services/pinia/AuthStore';

export default {
    name: 'SalesCrmCompanies',
    components: {
        SalesCrmUsersFilter,
        VueSelect,
        RednaxDatatable,
    },
    data: () => ({
        company_filter: {
            search: '',
            is_customer: null,
            user_id: null,
        },
        company_columns: [
            {
                header: 'Att göra',
                data: 'todo_date',
                sortable: true,
                render(row) {
                    return '<nobr>' + row.todo_date + '</nobr>';
                },
            },
            {
                header: 'Namn',
                data: 'name',
                sortable: true,
            },
            {
                header: 'Tillägg',
                data: 'suffix',
                sortable: true,
            },
            {
                header: 'Org.nr',
                data: 'org_no',
                sortable: true,
            },
            {
                header: 'Adress',
                data: 'address_street_1',
                sortable: true,
                render(row) {
                    let string = '';
                    if (row.address_street_1) string += `${row.address_street_1} `;
                    if (row.address_street_2) string += `${row.address_street_2} `;
                    if (row.address_postalcode) string += `${row.address_postalcode} `;
                    if (row.address_city) string += `${row.address_city} `;
                    return string;
                },
            },
            {
                header: 'Telefon',
                data: 'phone',
                sortable: true,
            },
            {
                header: 'Antal gåvor',
                data: 'gifts',
                sortable: true,
            },
            {
                header: 'Sommargåva',
                data: 'summer_gift',
                sortable: true,
            },
            {
                header: 'Taggar',
                data: 'tags',
                sortable: false,
            },
            {
                header: 'Kund',
                data: 'customer_ids',
                sortable: false,
            },
        ],
        customer_status_options: [
            {
                id: null,
                label: 'Inkl. kunder',
            },
            {
                id: 1,
                label: 'Endast kunder',
            },
            {
                id: 0,
                label: 'Dölj kunder',
            },
        ],
    }),
    mounted() {
        // this.company_filter.user_id = this.user.id;
    },
    methods: {
        rowClick(company) {
            this.$router.push({ name: 'crm.company', params: { id: company.id } });
        },
    },
    computed: {
        ...mapState(useAuthStore, ['user']),
    },
};
</script>

<style scoped>

</style>
